import InterviewSwitch from "pages/Testing/view/components/InterviewSwitch";
import ReportSwitch from "pages/Testing/view/components/ReportSwitch";
import { UseFormReturn } from "react-hook-form";
import { InfoInputs } from "../types";
import CandidateInfo from "./CandidateInfo";

interface InfoTabLeftProps {
  isEditing: boolean;
  form: UseFormReturn<InfoInputs>;
}

const InfoTabLeft = ({ isEditing, form }: InfoTabLeftProps) => {
  return (
    <>
      <InterviewSwitch />
      <ReportSwitch />
      <CandidateInfo
        form={form}
        isEditing={isEditing}
      />
    </>
  );
};

export default InfoTabLeft;
